import PageTitle from '../components/CommonComps/Titles/PageTitle';
import ServiceMutationModals from '../components/ServicesComps/ServiceMutationModals';
import ShowAllServices from '../components/ServicesComps/ShowAllServices';
import ServiceProvider from '../contexts/ServiceProvider';

const Services = () => {
  // rendering services page component here
  return (
    <>
      <PageTitle title='Services' />

      <ServiceProvider>
        <ShowAllServices />
        <ServiceMutationModals />
      </ServiceProvider>
    </>
  );
};

export default Services;
